import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GH } from '../theme';
import { GHLogo } from './GHLogo';
import { GHButton } from './GHButton';
import { useWindowWidth } from '../hooks/useWindowWidth';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const w = useWindowWidth();
  const mob = w < 768;
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const bg = scrolled ? 'rgba(255,255,255,0.97)' : 'rgba(255,255,255,0.85)';

  return (
    <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, background: bg, backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)', borderBottom: `1px solid ${scrolled ? GH.colors.borderDk : 'transparent'}`, transition: 'all 0.3s ease' }}>
      <div style={{ maxWidth: 1300, margin: '0 auto', padding: mob ? '0 20px' : '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 72 }}>
        <div style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
          <GHLogo />
        </div>
        {mob ? (
          <button onClick={() => setMenuOpen(!menuOpen)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8, fontSize: 24, color: GH.colors.charcoal }}>{menuOpen ? '✕' : '☰'}</button>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 36 }}>
            {NAV_LINKS.map(link => {
              const active = location.pathname === link.path;
              return (
                <a key={link.path} onClick={(e) => { e.preventDefault(); navigate(link.path); }} href={link.path}
                  style={{ fontFamily: GH.fonts.body, fontSize: 13, fontWeight: active ? 700 : 500, letterSpacing: '0.02em', color: active ? GH.colors.gold : GH.colors.white, textDecoration: 'none', cursor: 'pointer', transition: 'color 0.2s', borderBottom: active ? `2px solid ${GH.colors.gold}` : '2px solid transparent', paddingBottom: 4 }}
                  onMouseEnter={e => { if (!active) e.currentTarget.style.color = GH.colors.gold; }}
                  onMouseLeave={e => { if (!active) e.currentTarget.style.color = GH.colors.white; }}
                >{link.label}</a>
              );
            })}
            <GHButton size="sm" onClick={() => navigate('/quote')}>Get a Quote</GHButton>
          </div>
        )}
      </div>
      {mob && menuOpen && (
        <div style={{ background: '#fff', borderTop: `1px solid ${GH.colors.borderDk}`, padding: '20px', display: 'flex', flexDirection: 'column', gap: 4 }}>
          {NAV_LINKS.map(link => {
            const active = location.pathname === link.path;
            return (
              <a key={link.path} onClick={(e) => { e.preventDefault(); navigate(link.path); }} href={link.path}
                style={{ fontFamily: GH.fonts.body, fontSize: 15, fontWeight: active ? 700 : 500, color: active ? GH.colors.gold : GH.colors.white, textDecoration: 'none', padding: '12px 0', borderBottom: `1px solid ${GH.colors.borderDk}` }}
              >{link.label}</a>
            );
          })}
          <div style={{ marginTop: 12 }}>
            <GHButton fullWidth onClick={() => navigate('/quote')}>Get a Quote</GHButton>
          </div>
        </div>
      )}
    </nav>
  );
}
